export const FETCHING_SCORE_HISTOGRAM = 'fetching-score-histogram';
export const FETCH_SCORE_HISTOGRAM_SUCCESS = 'fetch-score-histogram-success';
export const FETCH_SCORE_HISTOGRAM_FAILED = 'fetch-score-histogram-failed';

export const FETCHING_AREA_HISTOGRAM = 'fetching-area-histogram';
export const FETCH_AREA_HISTOGRAM_SUCCESS = 'fetch-area-histogram-success';
export const FETCH_AREA_HISTOGRAM_FAILED = 'fetch-area-histogram-failed';

export const FETCH_HARVEST_RESULT_REQUEST = 'fetch-Harvest-result-request';
export const FETCH_HARVEST_RESULT_SUCCESS = 'fetch-Harvest-result-success';
export const FETCH_HARVEST_RESULT_FAILED = 'fetch-Harvest-result-failed';
